import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { SocialLink } from '@bd/bdcore-utilities';
import OSCTagMobile from './OSCTagMobile';


const styles = css`
  padding-top:60px;
  .Footer_content {
    font-size: 16px;
    padding: 20px 20px 100px 20px;
    text-align: center;
    background-position:bottom left;
    display:flex;
    flex-flow: row wrap;
    justify-content: center;
    @media (min-width: 992px) {
      text-align: left;
      padding: 150px 0 20px 0;
      justify-content: space-between;
      background: url('/images/rings.png') no-repeat;
    }
  }
  .Footer_socialLinks {
    padding: 0;
    text-align: center;
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    ul {
      padding:0 0 5px 0;
      margin:0;
      li {
        display: inline-block;
        margin: 0 0 0 20px;
        a img {
          height: 20px;
          width: auto;
          filter: brightness(30%);
        }
      }
      li:first-child {
        display: inline-block;
        margin: 0;
      }
    }
    @media (min-width: 992px) {
      text-align: right;
    }
  }
  .Footer_contactInfo {
    text-align: center;
    @media (min-width: 992px) {
      text-align: right;
    }
  }
  .Footer_EHOLogo {
    display: block;
    margin: 10px auto;
    @media (min-width: 992px) {
      display: inline-block;
      margin: -4px 0 0 10px;
      height: 18px;
      width: auto;
    }
  }
  .Footer_copyright {
    list-style-type:none;
    padding: 20px 0;
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    width:100%;
    @media (min-width: 992px) {
      padding: 20px 30px;
      width:auto;
    }
  }
  .Footer_inner {

    @media (min-width: 992px) {
    }
  }
  .addy {
    padding: 0 0 5px 0;
    @media (min-width: 992px) {
      padding: 0 40px 5px 0;
    }
    &.IconWrapper {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: center;
      @media (min-width: 992px) {
        justify-content: flex-end;
      }
      .IconWrapper_iconList {
        list-style: none;
        margin: 0;
        padding: 8px 0 5px 8px;
      }
    }
  }
`;

function Footer({ builder, widget }) {
  return (
    <div className={styles}>
      <div className="Footer_wrapper">
        <div className="Footer_inner">
          <div className="Footer_content">
            <ul className="Footer_copyright">
              <li>
                &copy;{(new Date()).getFullYear()} {get(builder, 'name')}.
                <div className="Footer_EHOLogo">
                  <img src="/images/heo.svg" alt="Equal Housing Opprotunity" />
                </div>
              </li>
              <li>Site By: <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer"><strong>Builder Designs</strong></a>.</li>
            </ul>

            <div className="Footer_socialLinks">
              <div className="addy">
                {get(builder, 'address.streetAddress')}, {get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.postalCode')}
              </div>
              <div className="addy">
                <ul>
                  {
                    get(builder, 'socialLinks', []).map(link => (
                      <li key={link}>
                        <SocialLink
                          url={link}
                        />
                      </li>
                    ))
                  }
                </ul>
              </div>
              <div className="addy IconWrapper">
                <a href="https://www.bbb.org/us/mn/ramsey/profile/home-builders/s-w-wold-construction-inc-0704-9001002/#sealclick" target="_blank" rel="noopener noreferrer"><img src="/images/bbb.svg" width="100" alt="Better Business Bureau" /></a>
                {
                  get(widget, 'footer_icons', []).length > 0 &&
                  <ul className="IconWrapper_iconList">
                    {
                      get(widget, 'footer_icons').map(item => (
                        <li key={item._id}><img src={get(item, 'icon.contentUrl')} width="100" alt={get(item, 'icon.title', get(item, 'icon.caption', ''))} /></li>
                      ))
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <OSCTagMobile />
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object,
};

Footer.defaultProps = {
  widget: undefined,
};

export default withData(
  {
    builder: true,
    widget: 'footer',
  },
  {
    required: {
      builder: true,
    },
  },
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js